import {
    CREATE_CHECKS_USER_FORM_ROLES,
    CREATE_ROLES_FAILURE,
    CREATE_ROLES_REQUEST,
    CREATE_ROLES_SUCCESS,
    CREATE_USER_FORM_ROLES,
    DELETE_ROLES_FAILURE,
    DELETE_ROLES_REQUEST,
    DELETE_ROLES_SUCCESS,
    FETCH_ROLES_FAILURE,
    FETCH_ROLES_REQUEST,
    FETCH_ROLES_SUCCESS,
    FETCH_SINGLE_ROLES_FAILURE,
    FETCH_SINGLE_ROLES_REQUEST,
    FETCH_SINGLE_ROLES_SUCCESS,
    ROLES_DROPDOWN_FAILURE,
    ROLES_DROPDOWN_REQUEST,
    ROLES_DROPDOWN_SUCCESS,
    ROLES_USERFORM_RESET,
    UPDATE_ROLES_FAILURE,
    UPDATE_ROLES_REQUEST,
    UPDATE_ROLES_SUCCESS
} from './roles.actionsType';

export const ROLES = 'Roles';

let initialState = {
    loading: false,
    allRoles: [],
    userform: {
        fldIsSuperAdmin: false,
        fldSuperAdmin: false,
        fldAdmin: false,
        fldViewOnly: false,
        fldCreate: false,
        fldEdit: false,
        fldDelete: false,
        fldEnableDisable: false,
        fldPrepare: false,
        fldVerify: false,
        fldAuthorize: false,
        fldAllowMobileAccess: false,
        fldAllowMobileInward: false,
        fldOTPApproval: false
    },
    roleList: {},
    sectionList: {},
    selectedRoles: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let rolesReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ROLES_REQUEST:
        case ROLES_DROPDOWN_REQUEST:
        case CREATE_ROLES_REQUEST:
        case FETCH_SINGLE_ROLES_REQUEST:
        case UPDATE_ROLES_REQUEST:
        case DELETE_ROLES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                allRoles: updatePayload
            };

        case ROLES_DROPDOWN_SUCCESS:
            if (payload == 33) {
                return {
                    ...state,
                    loading: false,
                    roleList: updatePayload
                };
            } else if (payload == 34) {
                return {
                    ...state,
                    loading: false,
                    sectionList: updatePayload
                };
            }
            break;
        case CREATE_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsSuperAdmin: false,
                    fldSuperAdmin: false,
                    fldAdmin: false,
                    fldViewOnly: false,
                    fldCreate: false,
                    fldEdit: false,
                    fldDelete: false,
                    fldEnableDisable: false,
                    fldPrepare: false,
                    fldVerify: false,
                    fldAuthorize: false,
                    fldAllowMobileAccess: false,
                    fldAllowMobileInward: false,
                    fldOTPApproval: false
                }
            };
        case FETCH_SINGLE_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedRoles: updatePayload,
                userform: updatePayload
            };

        case UPDATE_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsSuperAdmin: false,
                    fldSuperAdmin: false,
                    fldAdmin: false,
                    fldViewOnly: false,
                    fldCreate: false,
                    fldEdit: false,
                    fldDelete: false,
                    fldEnableDisable: false,
                    fldPrepare: false,
                    fldVerify: false,
                    fldAuthorize: false,
                    fldAllowMobileAccess: false,
                    fldAllowMobileInward: false,
                    fldOTPApproval: false
                },
                roleList: {},
                sectionList: {}
            };
        case DELETE_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsSuperAdmin: false,
                    fldSuperAdmin: false,
                    fldAdmin: false,
                    fldViewOnly: false,
                    fldCreate: false,
                    fldEdit: false,
                    fldDelete: false,
                    fldEnableDisable: false,
                    fldPrepare: false,
                    fldVerify: false,
                    fldAuthorize: false,
                    fldAllowMobileAccess: false,
                    fldAllowMobileInward: false,
                    fldOTPApproval: false
                },
                roleList: {},
                sectionList: {}
            };
        case FETCH_ROLES_FAILURE:
        case ROLES_DROPDOWN_FAILURE:
        case CREATE_ROLES_FAILURE:
        case FETCH_SINGLE_ROLES_FAILURE:
        case UPDATE_ROLES_FAILURE:
        case DELETE_ROLES_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ROLES:
            return {
                ...state,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_CHECKS_USER_FORM_ROLES:
            return {
                ...state,
                userform: {
                    ...state.userform,
                    [payload.key]: !state.userform[payload.key]
                }
            };
        case ROLES_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldIsSuperAdmin: false,
                    fldSuperAdmin: false,
                    fldAdmin: false,
                    fldViewOnly: false,
                    fldCreate: false,
                    fldEdit: false,
                    fldDelete: false,
                    fldEnableDisable: false,
                    fldPrepare: false,
                    fldVerify: false,
                    fldAuthorize: false,
                    fldAllowMobileAccess: false,
                    fldAllowMobileInward: false,
                    fldOTPApproval: false
                },
                roleList: {},
                sectionList: {},
                selectedRoles: {}
            };
        default:
            return state;
    }
};
